import React, { useState, useEffect } from "react";
import axios from "axios";
import {

  Appearance,
  loadStripe,
  StripeAddressElementOptions,

  StripeElementsOptions,

} from "@stripe/stripe-js";
import {
  Elements,
  useStripe,
  useElements,
  PaymentElement,
  AddressElement,
} from "@stripe/react-stripe-js";
import { format, Locale } from "date-fns";
import { enUS, fr, sv } from "date-fns/locale";
import "react-phone-number-input/style.css";
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
import { isValidPhoneNumber } from "react-phone-number-input";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import LoadingSpinner from "../Utilities/LoadSpinner";
import useFetchClientSecret from "./Payments/fetchClientSecret";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { PhoneNumberUtil } from "google-libphonenumber";

export interface CheckoutPageProps {
  customerId: string | null;
  cartItems: any[];
  setCartItems: (items: any[]) => void;
}

// Surface the backend's specific error/message (e.g. "Not enough availability
// for the selected date range.") instead of a generic string, so the user
// actually knows why a booking attempt failed.
const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error && typeof error === "object" && "response" in error) {
    const data = (error as { response?: { data?: { message?: string; error?: string; details?: string } } }).response?.data;
    return data?.message || data?.error || data?.details || fallback;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
};

const localeMap: { [key: string]: Locale } = {
  "en-US": enUS,
  "fr-FR": fr,
  "sv-SE": sv,
  sv: sv, // Add short code for Swedish
  // Add more mappings as needed
};
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
const currencyMap: { [key: string]: string } = {
  "en-US": "USD",
  "fr-FR": "EUR",
  "sv-SE": "SEK",
  sv: "SEK", // Add short code for Swedish
  // Add more mappings as needed
};
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Add email regex
const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone: string) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return false;
  }
};

const ensureHttps = (url: string) => {
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return `https://${url}`;
  }
  return url;
};

const apiUrl = ensureHttps(process.env.REACT_APP_API_URL || "defaultApiUrl");
console.log("API URL:", apiUrl); // Debugging log

const CheckoutPage: React.FC<CheckoutPageProps> = ({
  cartItems,
  setCartItems,
}) => {
  const [exchangeRates, setExchangeRates] = useState<{ [key: string]: number }>(
    {}
  );
  const [isBusinessUser, setIsBusinessUser] = useState(false);
  const [userInfo, setUserInfo] = useState<any>({});
  const [emailError, setEmailError] = useState<string | null>(null);
  const [cardholderNameError, setCardholderNameError] = useState<string | null>(
    null
  );

  const [paymentSuccess, setPaymentSuccess] = useState<boolean>(false);
  const [paymentError, setPaymentError] = useState<string | null>(null);
  const [cardholderName, setCardholderName] = useState<string>("");
  const apiUrl = ensureHttps(process.env.REACT_APP_API_URL || "defaultApiUrl");
  const [processing, setProcessing] = useState<boolean>(false);
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [defaultCountry, setDefaultCountry] = useState("US");

  //Business users
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [businessCode, setBusinessCode] = useState<string>("");
  const [businessUserInfo, setBusinessUserInfo] = useState<any>({});
  const [isBusinessInfoFetched, setIsBusinessInfoFetched] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [phone, setPhone] = useState<string>(""); // Add phone state

  const [phoneNumberError, setPhoneNumberError] = useState<string | null>(null);
  const [phoneTouched, setPhoneTouched] = useState<boolean>(false);

  // Retrieve the user's language and currency settings
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const userLanguage =
    localStorage.getItem("userLanguage") || navigator.language || "en-US";
  const [userLocale, setUserLocale] = useState<Locale>(enUS);
  const navigate = useNavigate();
  const { clientSecret, customerId } = useFetchClientSecret(
    cartItems,
    apiUrl || ""
  );
  console.log("Client Secret:", clientSecret); // Debugging log
  console.log("Customer ID:", customerId); // Debugging log
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    const fetchExchangeRates = async () => {
      try {
        const response = await fetch(
          "https://api.exchangerate-api.com/v4/latest/EUR"
        );
        if (!response.ok) {
          throw new Error("Failed to fetch exchange rates");
        }
        const data = await response.json();
        setExchangeRates(data.rates);
      } catch (error) {
        console.error("Error fetching exchange rates:", error);
      }
    };

    fetchExchangeRates();
  }, []);

  const formatDate = (date: string) => {
    const formattedDate = format(new Date(date), "PPP", { locale: userLocale });
    console.log("Formatted Date:", formattedDate); // Debugging log
    return formattedDate;
  };
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const formatDateToMidnight = (date: string) => {
    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0); // Set time to midnight
    return dateObj.toISOString();
  };

  const formatDateToYYYYMMDD = (date: string) => {
    const dateObj = new Date(date);
    const year = dateObj.getUTCFullYear();
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const convertCurrency = (
    amount: number,
    fromCurrency: string,
    toCurrency: string
  ) => {
    if (!exchangeRates[toCurrency]) {
      return amount; // Fallback to the original amount if exchange rate is not available
    }
    const rate = exchangeRates[toCurrency];
    return amount * rate;
  };

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(amount)
      .replace("EUR", "â‚¬");
  };

  // Business customers are invoiced at 20% off the gross price (matches
  // BookingService.cs's `itemTotalPrice *= 0.8m` applied at booking
  // confirmation, and the price shown in the confirmation email/invoice).
  // The cart/checkout UI must show this SAME net price at all times so the
  // customer never sees one number here and a different one on the invoice.
  const BUSINESS_DISCOUNT_MULTIPLIER = 0.8;
  const getDisplayPrice = (price: number) =>
    isBusinessUser ? price * BUSINESS_DISCOUNT_MULTIPLIER : price;

  const handleUserTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsBusinessUser(event.target.id === "business");
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
  
    if (name === "email") {
      validateEmail(value);
    } else if (name === "phoneNumber") {
      validatePhoneNumber(value);
    }
  
    setUserInfo((prevInfo: any) => ({ ...prevInfo, [name]: value }));
    if (isBusinessUser) {
      setBusinessUserInfo((prevInfo: any) => ({ ...prevInfo, [name]: value }));
    }
  };
  

  // Business users
  // Business users
  const fetchBusinessUserInfo = async () => {
    try {
      const businessCode = userInfo.businessCode;
      console.log("Fetching business user info with code:", businessCode); // Log business code

      const response = await axios.get(
        `${apiUrl}/BusinessUser/getBusinessUserByCode`,
        {
          params: { businessCode },
        }
      );

      console.log("API Response:", response); // Log the entire response

      const businessUserData = response.data as {
        name: string;
        email: string;
        phoneNumber: string;
        address: string;
        address2?: string;
        city: string;
        zipCode: string;
        country: string;
        id: string;
      }; // Access the data directly

      console.log("Fetched Business User Data:", businessUserData); // Log fetched data

      setBusinessUserInfo((prevInfo: any) => ({
        ...prevInfo,
        name: businessUserData.name,
        email: businessUserData.email,
        phoneNumber: businessUserData.phoneNumber,
        address: businessUserData.address,
        address2: businessUserData.address2,
        city: businessUserData.city,
        zipCode: businessUserData.zipCode,
        country: businessUserData.country,
        businessUserId: businessUserData.id, // Set BusinessUserId
      }));

      setIsBusinessInfoFetched(true);
    } catch (error) {
      console.log("Error fetching business user info:", error);
      setPaymentError(
        "An error occurred while fetching business user information."
      );
    }
  };

  // useEffect(() => {
  //   console.log("Business User Info:", businessUserInfo);
  // }, [businessUserInfo]);

  // useEffect(() => {
  //   console.log("User Info:", userInfo); // Log userInfo to check its value
  //   if (userInfo.isBusinessUser) {
  //     fetchBusinessUserInfo(); // Call fetch function only if the user is a business user
  //   }
  // }, [userInfo.isBusinessUser]);

  // Function to get the total amount from the shopping cart
  const getTotalAmount = () => {
    console.log("Cart Items:", cartItems); // Log cart items
    const totalAmount = cartItems.reduce((total, item) => {
      const itemTotalPrice = parseFloat(item.totalPrice);
      if (isNaN(itemTotalPrice)) {
        console.error("Invalid totalPrice for item:", item);
        return total;
      }
      console.log("Item totalPrice:", itemTotalPrice); // Log each item's totalPrice
      return total + itemTotalPrice;
    }, 0);
    console.log("Total Amount:", totalAmount); // Log the total amount
    return totalAmount;
  };
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const createPaymentIntentForBusinessUser = async () => {
    try {
      const response = await axios.post(
        `${apiUrl}/Payments/createPaymentIntent`,
        {
          isBusinessUser: true,
          description: "Payment for business user",
          paymentMethodTypes: ["invoice"], // Provide as a list of strings
          items: cartItems.map((item) => ({
            packageId: item.packageId,
            pricingModelId: item.pricingModelId,
            categoryId: item.categoryId,
            arrivalDate: item.arrivalDate,
            departureDate: item.departureDate,
            pricePerNight: item.pricePerNight,
          })),
          // Include other required fields
          amount: getTotalAmount(), // Assuming you have a function to calculate the total amount
          currency: "EUR",
          sessionId: localStorage.getItem("sessionId"),
          email: userInfo.email,
          customerName: userInfo.name,
          phoneNumber: userInfo.phoneNumber,
          address: userInfo.address,
          addressLine2: userInfo.address2,
          city: userInfo.city,
          state: userInfo.state,
          zipCode: userInfo.zipCode,
          country: userInfo.country,
          businessUserId: businessUserInfo.businessUserId, // Ensure BusinessUserId is included
        }
      );
      const data = response.data as { paymentIntentId: string };
      return data.paymentIntentId;
    } catch (error) {
      console.log("Error creating payment intent for business user:", error);
      throw new Error("Failed to create payment intent");
    }
  };

  const handleConfirmBusinessInfo = async () => {
    setProcessing(true); // Add this line to show processing message
    try {
      const sessionId = localStorage.getItem("sessionId");
      if (!sessionId) {
        throw new Error("Session ID not found in local storage");
      }

      const userInfoPayload = {
        ...userInfo,
        name: businessUserInfo.name,
        customerName: businessUserInfo.name,
        email: businessUserInfo.email,
        phoneNumber: businessUserInfo.phoneNumber,
        address: businessUserInfo.address,
        address2: businessUserInfo.address2,
        city: businessUserInfo.city,
        zipCode: businessUserInfo.zipCode,
        country: businessUserInfo.country,
        isBusinessUser: true,
        sessionId,
        items: cartItems.map((item) => ({
          packageId: item.packageId,
          pricingModelId: item.pricingModelId,
          categoryId: item.categoryId,
          arrivalDate: formatDateToYYYYMMDD(item.arrivalDate),
          departureDate: formatDateToYYYYMMDD(item.departureDate),
          pricePerNight: item.pricePerNight,
        })),
      };

      console.log("User Info Payload for Business User:", userInfoPayload);

      const bookingResponse = await axios.post(
        `${apiUrl}/PackageBooking/confirmpackagebooking`,
        userInfoPayload
      );
      console.log("Booking confirmed for Business User:", bookingResponse);

      const bookingData = bookingResponse.data as { isBusinessUser: boolean };
      const isBusinessUser = bookingData.isBusinessUser;

      setPaymentSuccess(true);
      setProcessing(false);
      setCartItems([]);
      navigate(`/payment-success?status=success`, {
        state: {
          orderSummary: cartItems,
          isBusinessUser,
       //   receiptUrl: bookingData.receiptUrl,
        },
      });
    } catch (error) {
      setPaymentError(
        getErrorMessage(error, "An error occurred while processing the business user submission")
      );
      setProcessing(false);
      console.log("Error during business user submission:", error);
    }
  };

  // Functions to handle submit and cancel actions
  const handleUpdateSubmit = async () => {
    try {
      const response = await axios.put(
        `${apiUrl}/BusinessUser/updateBusinessUserByCode`,
        businessUserInfo,
        {
          headers: { 
            'Authorization': userInfo.businessCode,
            'BusinessCode': userInfo.businessCode 
          },
          params: { businessCode: userInfo.businessCode },
        }
      );
  
      console.log("Business user information updated:", response.data);
  
      setUserInfo((prevInfo: any) => ({
        ...prevInfo,
        name: businessUserInfo.name,
        email: businessUserInfo.email,
        phoneNumber: businessUserInfo.phoneNumber,
        address: businessUserInfo.address,
        address2: businessUserInfo.address2,
        city: businessUserInfo.city,
        zipCode: businessUserInfo.zipCode,
        country: businessUserInfo.country,
      }));
  
      setIsUpdating(false);
    } catch (error) {
      console.error("Error updating business user information:", error);
      setPaymentError("An error occurred while updating business user information.");
    }
  };

  const handleCancelUpdate = () => {
    // Logic to handle the cancellation of updating business information
    setIsUpdating(false);
  };

  useEffect(() => {
    const userLanguage = navigator.language || navigator.languages[0];
    const userLocale = localeMap[userLanguage] || enUS;
    setUserLocale(userLocale as any);
  }, []);

  const handlePhoneNumberChange = (value?: string) => {
    const phone = value || "";
    setUserInfo((prevUserInfo: any) => ({
      ...prevUserInfo,
      phoneNumber: phone,
    }));
    setPhoneNumber(phone);
    if (phoneTouched) {
      validatePhoneNumber(phone);
    }
  };

  const validatePhoneNumber = (phoneNumber: string) => {
    console.log("Validating phone number:", phoneNumber);
    if (!phoneNumber || !isPhoneValid(phoneNumber)) {
      console.log("Invalid phone number:", phoneNumber);
      setPhoneNumberError("Please enter a valid phone number.");
    } else {
      console.log("Valid phone number:", phoneNumber);
      setPhoneNumberError("");
    }
  };

  const handlePhoneBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    event.preventDefault();
    setPhoneTouched(true);
    validatePhoneNumber(phoneNumber);
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
    }
  };

  const validateCardholderName = (name: string) => {
    if (name.length < 3) {
      setCardholderNameError(
        "Cardholder name must be at least 3 characters long."
      );
    } else {
      setCardholderNameError("");
    }
  };

  const handleCardholderNameChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;
    setCardholderName(value);
    validateCardholderName(value);
  };
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handlePhoneNumberKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const handlePaymentSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setProcessing(true);
    console.log("Payment processing started");

    if (!stripe || !elements) {
      setPaymentError("Stripe has not been loaded properly.");
      setProcessing(false);
      console.log("Stripe or elements not loaded");
      return;
    }

    // Validate phone number before proceeding
    if (!userInfo.phoneNumber || !isPhoneValid(userInfo.phoneNumber)) {
      setPhoneNumberError("Please enter a valid phone number.");
      setProcessing(false);
      console.log("Phone number validation failed");
      return;
    }

    const addressElement = elements.getElement(AddressElement);
    const addressElementValue = await addressElement?.getValue();
    const addressDetails = addressElementValue
      ? addressElementValue.value
      : null;

    const cardElement = elements.getElement(PaymentElement);

    if (!cardElement) {
      setPaymentError("Payment Element is not mounted.");
      setProcessing(false);
      console.log("Payment Element is not mounted");
      return;
    }

    try {
      console.log("Confirming payment...");
      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/payment-success`,
        },
        redirect: "if_required",
      });

      console.log("Payment confirmation result:", result);

      if (result.error) {
        setPaymentError(result.error.message ?? "An unknown error occurred");
        setProcessing(false);
        console.log("Error in payment confirmation:", result.error.message);
        return;
      }

      if (result.paymentIntent) {
        const paymentIntent = result.paymentIntent;
        console.log("Payment Intent:", paymentIntent);

        const paymentIntentId = paymentIntent.id;

        const userInfoPayload = {
          ...userInfo,
          paymentIntentId,
          sessionId: localStorage.getItem("sessionId"),
          name: addressDetails?.name,
          email: userInfo.email, // Ensure correct field
          phoneNumber: userInfo.phoneNumber, // Ensure correct field name
          address: addressDetails?.address.line1,
          addressLine2: addressDetails?.address.line2,
          city: addressDetails?.address.city,
          state: addressDetails?.address.state,
          zipcode: addressDetails?.address.postal_code,
          country: addressDetails?.address.country,
          customerId: customerId, // Include customerId in the payload
          items: cartItems.map((item) => ({
            packageId: item.packageId,
            pricingModelId: item.pricingModelId,
            arrivalDate: formatDateToYYYYMMDD(item.arrivalDate),
            departureDate: formatDateToYYYYMMDD(item.departureDate),
          })),
        };

        console.log("User Info Payload:", userInfoPayload);

        const userInfoResponse = await axios.post(
          `${apiUrl}/PrivateUser/userInfo`,
          userInfoPayload
        );
        console.log("User info submitted:", userInfoResponse);

        const bookingResponse = await axios.post(
          `${apiUrl}/PackageBooking/confirmpackagebooking`,
          {
            paymentIntentId,
            sessionId: localStorage.getItem("sessionId"),
            customerName: addressDetails?.name,
            email: userInfo.email, // Ensure email is passed here
            items: cartItems.map((item) => ({
              packageId: item.packageId,
              pricingModelId: item.pricingModelId,
              arrivalDate: formatDateToYYYYMMDD(item.arrivalDate),
              departureDate: formatDateToYYYYMMDD(item.departureDate),
            })),
            customerId: customerId, // Include customerId in the booking payload
          }
        );
        console.log("Booking confirmed:", bookingResponse);

        const receiptUrl = (bookingResponse.data as { receiptUrl: string }).receiptUrl;

        setPaymentSuccess(true);
        setProcessing(false);
        setCartItems([]);
        navigate(`/payment-success?status=success`, {
          state: { orderSummary: cartItems, customerId, receiptUrl },
        });
      } else {
        setPaymentError("Payment Intent is missing from the response.");
        setProcessing(false);
        console.log("Payment Intent missing from response");
      }
    } catch (error) {
      setPaymentError(getErrorMessage(error, "An error occurred while processing the payment"));
      setProcessing(false);
      console.log("Error during payment processing:", error);
    }
  };
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter" && (e.target as HTMLElement).tagName === "INPUT") {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const elementsOptions: StripeElementsOptions = {
    clientSecret: clientSecret!,
    fonts: [
      {
        family: "Poppins",
        src: 'url(/fonts/Poppins/Poppins-Regular.woff2) format("woff2")',
        weight: "400",
      },
      {
        family: "Poppins",
        src: 'url(/fonts/Poppins/Poppins-Regular.woff2) format("woff2")',
        weight: "500",
      },
      {
        family: "Poppins",
        src: 'url(/fonts/Poppins/Poppins-Bold.woff2) format("woff2")',
        weight: "700",
      },
    ],
    appearance: {
      theme: "stripe",
      variables: {
        colorPrimary: "#0570de",
        colorBackground: "#ffffff",
        colorText: "#30313d",
        colorDanger: "#df1b41",
        fontFamily: "Poppins, sans-serif",
        spacingUnit: "2px",
        borderRadius: "4px",
        fontSizeBase: "16px",
      },
      rules: {
        ".Input": {
          padding: "12px",
          borderColor: "#ccc",
          outline: "none",
          boxShadow: "none",
          fontFamily: "Poppins, sans-serif",
          fontWeight: "400",
        },
        ".Input:focus": {
          outline: "none",
          boxShadow: "none",
          borderColor: "#ccc",
        },
        ".Input--invalid": {
          outline: "none",
          boxShadow: "none",
          borderColor: "#df1b41",
        },
        ".Label": {
          fontFamily: "Poppins, sans-serif",
          padding: "8px",
          fontSize: "14px",
          fontWeight: "700",
        },
        ".AddressElement": {
          padding: "12px",
          borderColor: "#ccc",
          outline: "none",
          boxShadow: "none",
          fontFamily: "Poppins, sans-serif",
          fontWeight: "400",
        },
        ".AddressElement:focus": {
          outline: "none",
          boxShadow: "none",
          borderColor: "#ccc",
        },
        ".AddressElement--invalid": {
          outline: "none",
          boxShadow: "none",
          borderColor: "#df1b41",
        },
        ".p-FieldLabel": {
        fontSizeBase: "12px",
        textWrap: "nowrap",
        whiteSpace: "nowrap", // Prevent text wrapping
        overflow: "hidden", // Hide overflow text
        textOverflow: "ellipsis", // Add ellipsis for overflow text
      },
      },
    },
  };
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const addressElementOptions: StripeAddressElementOptions = {
    mode: "billing",
  };

  const handlePreBooking = async () => {
    try {
      const sessionId = localStorage.getItem("sessionId");
      if (!sessionId) {
        throw new Error("Session ID not found in local storage");
      }

      const userInfoPayload = {
        ...userInfo,
        name: businessUserInfo.name,
        customerName: businessUserInfo.name,
        email: businessUserInfo.email,
        phoneNumber: businessUserInfo.phoneNumber,
        address: businessUserInfo.address,
        address2: businessUserInfo.address2,
        city: businessUserInfo.city,
        zipCode: businessUserInfo.zipCode,
        country: businessUserInfo.country,
        isBusinessUser: true,
        sessionId,
        items: cartItems.map((item) => ({
          packageId: item.packageId,
          pricingModelId: item.pricingModelId,
          categoryId: item.categoryId,
          arrivalDate: formatDateToYYYYMMDD(item.arrivalDate),
          departureDate: formatDateToYYYYMMDD(item.departureDate),
          pricePerNight: item.pricePerNight,
        })),
      };

      console.log("User Info Payload for Pre-Booking:", userInfoPayload);

      const preBookingResponse = await axios.post(
        `${apiUrl}/PackageBooking/prebooking`,
        userInfoPayload
      );
      console.log("Pre-Booking confirmed for Business User:", preBookingResponse);

      const preBookingData = preBookingResponse.data as { isBusinessUser: boolean };
      const isBusinessUser = preBookingData.isBusinessUser;

      setPaymentSuccess(true);
      setProcessing(false);
      setCartItems([]);
      navigate(`/payment-success?status=success`, {
        state: {
          orderSummary: cartItems,
          isBusinessUser,
          // receiptUrl: preBookingData.receiptUrl,
        },
      });
    } catch (error) {
      setPaymentError(
        getErrorMessage(error, "An error occurred while processing the pre-booking")
      );
      setProcessing(false);
      console.log("Error during pre-booking:", error);
    }
  };

  const [isPreBooking, setIsPreBooking] = useState(false);

  const handlePreBookingChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsPreBooking(event.target.value === "yes");
  };

  return (
    <div className="container-fluid checkout-page pb-5 mb-5">
      <div className="checkout-container">
        <div className="cart-items-section">
          <h2>Cart Items</h2>
          <ul>
            {cartItems.map((item, index) => (
              <li key={index} className="cart-item">
                <img
                  src={item.mainPictureUrl}
                  alt={item.packageName}
                  className="cart-item-image"
                />
                <div className="cart-item-details">
                  <div>
                    <strong>Package:</strong>
                    <span className="cart-item-name">
                      <Link
                        to={`/package/${item.packageId}`}
                        state={{
                          dateRange: {
                            arrivalDate: item.arrivalDate,
                            departureDate: item.departureDate,
                          },
                        }}
                      >
                        {item.packageName}
                      </Link>
                    </span>
                  </div>
                  <div>
                    <strong>Chosen option</strong>{" "}
                    {item.pricingModelDescription}
                  </div>
                  <div>
                    <strong>Arrival Date:</strong>{" "}
                    {formatDate(item.arrivalDate)}
                  </div>
                  <div>
                    <strong>Departure Date:</strong>{" "}
                    {formatDate(item.departureDate)}
                  </div>
                  <div>
                    <strong>Price per person:</strong>{" "}
                    {formatCurrency(getDisplayPrice(item.maxPersons > 0 ? item.totalPrice / item.maxPersons : item.totalPrice))}
                  </div>
                  <div>
                    <strong>Total Price:</strong>{" "}
                    {formatCurrency(getDisplayPrice(item.totalPrice))}
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <div className="cart-total ">
            <strong>Total Cost:&nbsp;</strong>{" "}
            {formatCurrency(
              getDisplayPrice(cartItems.reduce((total, item) => total + item.totalPrice, 0))
            )}
            {isBusinessUser && (
              <div><small>Net price (20% business discount applied, VAT excluded)</small></div>
            )}
          </div>
        </div>
        {clientSecret && (
          <form
            onSubmit={handlePaymentSubmit}
            className="form-and-payment-container"
          >
            <div className="user-info-section">
              <h2>User Information</h2>
              <div className="user-type-group">
                <div className="form-group">
                  <label htmlFor="business">Business User</label>
                  <input
                    type="checkbox"
                    id="business"
                    name="business"
                    checked={isBusinessUser}
                    onChange={handleUserTypeChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="private">Private User</label>
                  <input
                    type="checkbox"
                    id="private"
                    name="private"
                    checked={!isBusinessUser}
                    onChange={handleUserTypeChange}
                  />
                </div>
              </div>
              {isBusinessUser && (
                <>
                  <div className="form-group">
                    <label htmlFor="businessCode">Business Code:</label>
                    <input
                      type="text"
                      id="businessCode"
                      name="businessCode"
                      value={userInfo.businessCode}
                      onChange={handleInputChange}
                      required
                    />
                    <button
                      className="mt-2"
                      type="button"
                      onClick={fetchBusinessUserInfo}
                    >
                      Fetch Info
                    </button>
                  </div>
                  {isBusinessInfoFetched && businessUserInfo && !isUpdating && (
                    <div className="business-info-display">
                      <p>
                        <strong>Company:</strong> {businessUserInfo.name}
                      </p>
                      <p>
                        <strong>Email:</strong> {businessUserInfo.email}
                      </p>
                      <p>
                        <strong>Phone:</strong> {businessUserInfo.phoneNumber}
                      </p>
                      <p>
                        <strong>Address:</strong> {businessUserInfo.address}
                      </p>
                      <p>
                        <strong>City:</strong> {businessUserInfo.city}
                      </p>
                      <p>
                        <strong>Zip Code:</strong> {businessUserInfo.zipCode}
                      </p>
                      <p>
                        <strong>Country:</strong> {businessUserInfo.country}
                      </p>
                      <hr />
                      <div className="pre-booking">
                        <label>Is this a Pre-Booking?</label>
                        <div>
                          <input
                            type="radio"
                            id="preBookingYes"
                            name="preBooking"
                            value="yes"
                            checked={isPreBooking === true}
                            onChange={handlePreBookingChange}
                          />
                          <label htmlFor="preBookingYes">Yes</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="preBookingNo"
                            name="preBooking"
                            value="no"
                            checked={isPreBooking === false}
                            onChange={handlePreBookingChange}
                          />
                          <label htmlFor="preBookingNo">No</label>
                        </div>
                      </div>
                      <hr />
                      <div className="business-info-buttons">
                        <button
                          type="button"
                          onClick={() => setIsUpdating(true)}
                        >
                          Update Business Information
                        </button>
                        <button
                          className="ms-2"
                          type="button"
                          onClick={isPreBooking ? handlePreBooking : handleConfirmBusinessInfo}
                        >
                          Yes, use this information
                        </button>
                      </div>
                      {processing && (
                        <div className="processing-message">Processing order...</div>
                      )}
                      {paymentError && (
                        <div className="error">{paymentError}</div>
                      )}
                    </div>
                  )}
                  {isUpdating && (
                    <>
                      <div className="form-group">
                        <label htmlFor="company">Company:</label>
                        <input
                          type="text"
                          id="company"
                          name="name"
                          value={businessUserInfo.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="businessemail">Email:</label>
                        <input
                          type="email"
                          id="businessemail"
                          name="email"
                          value={businessUserInfo.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="businessphone">Phone:</label>
                        <input className="pe-2 "
                          type="tel"
                          id="businessphone"
                          name="phoneNumber"
                          value={businessUserInfo.phoneNumber}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="businessaddress">Street Address:</label>
                        <input
                          type="text"
                          id="businessaddress"
                          name="address"
                          value={businessUserInfo.address}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="businessaddress2">
                          Address Line 2:
                        </label>
                        <input
                          type="text"
                          id="businessaddress2"
                          name="address2"
                          value={businessUserInfo.address2}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="businesscity">City:</label>
                        <input
                          type="text"
                          id="businesscity"
                          name="city"
                          value={businessUserInfo.city}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="businesszip">Zip Code:</label>
                        <input
                          type="text"
                          id="businesszip"
                          name="zipCode"
                          value={businessUserInfo.zipCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="businesscountry">Country:</label>
                        <input
                          type="text"
                          id="businesscountry"
                          name="country"
                          value={businessUserInfo.country}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group d-flex justify-content-flext-start">
                        <button className="me-3" type="button" onClick={handleUpdateSubmit}>
                          Submit
                        </button>
                        <button type="button" onClick={handleCancelUpdate}>
                          Cancel
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
              {!isBusinessUser && (
                <>
                  <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={userInfo.email}
                      onChange={handleInputChange}
                      required
                      className={emailError ? "invalid" : ""}
                    />
                    {emailError && <div className="error">{emailError}</div>}
                  </div>
                  <div className="form-group pe-2">
                    <label htmlFor="phoneNumber">Phone:</label>
                  </div>
                  <PhoneInput className="pe-2 ps-2"
                    inputClassName={phoneNumberError ? "invalid" : ""}
                    name="phoneNumber"
                    value={userInfo.phoneNumber}
                    onChange={handlePhoneNumberChange}
                    onBlur={handlePhoneBlur}
                    defaultCountry={defaultCountry as any}
                  />
                  {phoneNumberError && (
                    <div className="error ps-2 pe-2">{phoneNumberError}</div>
                  )}
                  <div className="form-group mt-4">
                    <label htmlFor="address">Address:</label>
                    <AddressElement options={{ mode: "billing" }} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="comments">Comments:</label>
                    <textarea
                      id="comments"
                      value={userInfo.comments}
                      onChange={handleInputChange}
                      name="comments"
                    />
                  </div>
                </>
              )}
            </div>
            <div
              className={`payment-options-section ${
                isBusinessUser ? "hidden" : ""
              }`}
            >
              {!isBusinessUser && (
                <>
                  <h2>Payment Options</h2>
                  <div className="form-group">
                    <label htmlFor="cardholderName">Cardholder Name</label>
                    <div>
                      <input
                        type="text"
                        id="cardholderName"
                        value={cardholderName}
                        onChange={handleCardholderNameChange}
                      />
                      {cardholderNameError && (
                        <div className="error">{cardholderNameError}</div>
                      )}
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="paymentElement">Card Details</label>
                    <PaymentElement id="paymentElement" />
                  </div>
                </>
              )}
              <div className="pt-2 ps-2 pe-2">
                {!isBusinessUser && (
                  <button
                    className="payment-button"
                    type="submit"
                    onClick={handlePaymentSubmit}
                    disabled={processing}
                  >
                    <FontAwesomeIcon icon={faShoppingCart} className="icon" />{" "}
                    Place Order
                  </button>
                )}
                {processing && (
                  <div className="processing-message">Processing order...</div>
                )}
              </div>
              {paymentError && <div className="error">{paymentError}</div>}
              {paymentSuccess && (
                <div className="success-message">Payment successful</div>
              )}
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

const WrappedCheckoutPage: React.FC<CheckoutPageProps> = (props) => {
  const apiUrl = ensureHttps(process.env.REACT_APP_API_URL || "defaultApiUrl");
  console.log("Wrapped API URL:", apiUrl); // Debugging log
  const { clientSecret, customerId } = useFetchClientSecret(
    props.cartItems,
    apiUrl || ""
  );
  console.log("Wrapped Client Secret:", clientSecret); // Debugging log
  console.log("Wrapped Customer ID:", customerId); // Debugging log

  const appearance: Appearance = {
    theme: "stripe",
    variables: {
      colorPrimary: "#0570de",
      colorBackground: "#ffffff",
      colorText: "#30313d",
      colorDanger: "#df1b41",
      fontFamily: "Poppins, sans-serif",
      spacingUnit: "2px",
      borderRadius: "4px",
      fontSizeBase: "16px",
    },
    rules: {
      ".Input": {
        padding: "12px",
        borderColor: "#ccc",
        outline: "none",
        boxShadow: "none",
        fontFamily: "Poppins, sans-serif",
        fontWeight: "400",
      },
      ".Input:focus": {
        outline: "none",
        boxShadow: "none",
        borderColor: "#ccc",
      },
      ".Input--invalid": {
        outline: "none",
        boxShadow: "none",
        borderColor: "#df1b41",
      },
      ".Label": {
        fontFamily: "Poppins, sans-serif",
        padding: "8px",
        fontSize: "16px",
        fontWeight: "700",
        whiteSpace: "nowrap", // Prevent text wrapping
        overflow: "hidden", // Hide overflow text
        textOverflow: "ellipsis", // Add ellipsis for overflow text
      },
      ".AddressElement": {
        padding: "12px",
        borderColor: "#ccc",
        outline: "none",
        boxShadow: "none",
        fontFamily: "Poppins, sans-serif",
        fontWeight: "400",
      },
      ".AddressElement:focus": {
        outline: "none",
        boxShadow: "none",
        borderColor: "#ccc",
      },
      ".AddressElement--invalid": {
        outline: "none",
        boxShadow: "none",
        borderColor: "#df1b41",
      },
      ".p-FieldLabel": {
        fontSizeBase: "12px",
        textWrap: "nowrap",
        whiteSpace: "nowrap", // Prevent text wrapping
        overflow: "hidden", // Hide overflow text
        textOverflow: "ellipsis", // Add ellipsis for overflow text
      },
    },
  };
  const stripePromise = loadStripe(
    "pk_test_51Q3HAfRu0BKfw7x3hwbBUYNcXCte5sstUsXxRITFAO5c2J5thCmAqQCZXlS3bAv9n5IAFlCfO2L4IipExZDmxiAD00kp0i9g0U"
  );

  if (!clientSecret) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <Elements stripe={stripePromise} options={{ appearance, clientSecret }}>
        <CheckoutPage {...props} customerId={customerId} />
      </Elements>
    </div>
  );
};

export default WrappedCheckoutPage;
